import './Playlist.css';

function SoundCloudPlayer({ trackUrl, trackTitle, isSelected, onToggle }) {
  const buttonStyle = {
    backgroundColor: 'transparent',
    width: "3.5rem",
    color: '#e1581d',
    borderColor: '#e1581d',
    fontSize: '16px',
    cursor: 'pointer',
  };

  const buttonHoverStyle = {
    width: "3.5rem",
    color: 'white',
    backgroundColor: '#e1581d'
  };
  return (
    <div className={`soundcloud ${isSelected ? 'selected' : ''}`}>
      <button
        className="close-button"
        onClick={onToggle}
        style={buttonStyle}
        onMouseEnter={(e) => {
          e.target.style = { ...e.target.style, ...buttonHoverStyle };
        }}
        onMouseLeave={(e) => {
          e.target.style = buttonStyle;
        }}
      >
        X
      </button>
      <div className="soundcloud-container">
        <iframe
          width="60%"
          height="500"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(trackUrl)}&color=%23fdb191&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true`}
          title="SoundCloud Player"
        ></iframe>
        <div style={{ fontSize: "10px", color: "#cccccc", lineHeight: "1.4", fontFamily: "Interstate, Lucida Grande, sans-serif", fontWeight: "100" }}>
          <a href="https://soundcloud.com/aethelmusic" title="aethel" target="_blank" rel="noreferrer" style={{ color: "#cccccc", textDecoration: "none" }}>
            Aethel
          </a>{" "}
          ·{" "}
          <a href={trackUrl} title={trackTitle} target="_blank" rel="noreferrer" style={{ color: "#cccccc", textDecoration: "none" }}>
            {trackTitle}
          </a></div>
      </div>
    </div>
  );
}

export default SoundCloudPlayer;



